// src/helpers/projectsApi.js


function getChamVizSaveData() {
  const chamviz = document.getElementById('chamViz');
  if (!chamviz || typeof chamviz.getSaveData !== 'function') {
    throw new Error("The visualizer isn't ready yet. Try again in a moment.");
  }
  return chamviz.getSaveData();
}

export function toQueryParamsObject(search = '') {
  return Object.fromEntries(new URLSearchParams(search));
}

export function makeCompactAppliedProducts(appliedProducts, key = 'chamViz') {
  const src = key && appliedProducts?.[key] ? appliedProducts[key] : appliedProducts;
  if (!src || typeof src !== 'object') return {};

  const compact = {};
  Object.entries(src).forEach(([surface, obj]) => {
    const data = obj?.colorway;
    if (!data) return;

    compact[surface] = {
      styleCode: data.thumbnailRenderOptions ?? "null",
      colorCode: data.efficiency ?? "",
      sku: data.sku ?? "",
      color: data.color ?? "",
      name: data.name ?? "",
      // keep these if present
      selStrings: obj?.selStrings ?? [],
      size: obj?.size ?? null,
      install: obj?.install ?? null,
    };
  });
  return compact;
}

export function buildPayload({ specifier, sel, queryParams, compactAppliedProducts,activeFlooringSeriesIds,submenu, renderSize = 1024 }) {
  const seriesUsed = [...new Set([...(activeFlooringSeriesIds ?? []), 8642, 7973])];

  const projectUrl =
  `${window.location.origin}/visualizer/spec/${encodeURIComponent(specifier)}` +
  `/sel/${encodeURIComponent(sel)}` +
  `?sids=${encodeURIComponent(activeFlooringSeriesIds)}`;


  const renderUrl = (() => {
    const u = new URL("https://renderfarm2.chameleonpower.com/proxy/GetImage.ashx");
    u.searchParams.set("spec", specifier);
    u.searchParams.set("sel", sel);
    u.searchParams.set("Size", String(renderSize ?? 300)); // default if needed
    u.searchParams.set("type", "base");
    return u.toString();
  })();

  return {
    specifier,
    selstring: sel,
    projectUrl,
    renderUrl,
    queryParams,
    appliedProducts: compactAppliedProducts,
    seriesUsed,
  };

}

export function postSaveToParent(payload, targetOrigin = "*", targetWindow = window.parent) {
    console.log(payload)
    targetWindow.postMessage({ type: "SAVE_REQUEST", payload }, targetOrigin);
}


export function fetchProjects({ locationSearch, targetOrigin = "*", targetWindow = window.parent }) {
  const queryParams = Object.fromEntries(new URLSearchParams(locationSearch));

  const payload = {
    type: "FETCH_PROJECTS",
    queryParams,
    requestedAt: Date.now(),
  };

  targetWindow.postMessage(payload, targetOrigin);
  return payload; // useful for debugging
}



export function saveProject({ specifier, appliedProducts, locationSearch, appliedKey = 'chamViz',activeFlooringSeriesIds,submenu }) {
  if (!appliedProducts?.[appliedKey]) {
    throw new Error("Please select a product before saving.");
  }

  const saveData = getChamVizSaveData();
  const queryParams = toQueryParamsObject(locationSearch);
  const compact = makeCompactAppliedProducts(appliedProducts, appliedKey);
  const payload = buildPayload({
    specifier,
    sel: saveData.sel,
    queryParams,
    compactAppliedProducts: compact,
    activeFlooringSeriesIds,
    submenu
  });

  postSaveToParent(payload);
  return payload; // handy for logging/tests
}
